/*
 * @author Sergey Kuzhavskiy <Praffesor>
 */
angular.module('sign.client', ['data.client-manager', 'sign.client.registration']);
